import '../Navbar/Navbar.css'
import Gatisheellogo from './Gatisheel logo.png';
import Navtab1 from '../Navbar/Navtab1';
import Navtab2 from '../Navbar/Navtab2';
import Navtab3 from '../Navbar/Navtab3';

// function Mnavbar()
// {
//     return (
//         <>
//             <nav className="navbar navbar-expand-lg bg-success" style={{ width: "100%" }} >
//                 <div className="container-fluid" style={{ width: "100%", height: "auto" }} >
//                     <img src={Gatisheellogo} style={{ width: "60px", height: "60px" }} alt=" " />
//                     <a className="navbar-brand ps-3" href="https://www.gatisheel.com/" style={{color: "white",fontSize: "30px",fontWeight: "bold"}} >
//                         GATISHEEL{" "}
//                     </a>
//                     <button
//                         className="navbar-toggler"
//                         type="button"
//                         data-bs-toggle="collapse"
//                         data-bs-target="#navbarSupportedContent"
//                         aria-controls="navbarSupportedContent"
//                         aria-expanded="false"
//                         aria-label="Toggle navigation"
//                     >
//                         <span className="navbar-toggler-icon"></span>
//                     </button>
//                     <div
//                         className="collapse navbar-collapse"
//                         id="navbarSupportedContent"
//                     >
//                         <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            
//                             <Navtab1 />
//                             <Navtab2 />
//                             <Navtab3 />
//                         </ul>
//                         <form className="d-flex" role="search">
//                             <input
//                                 className="form-control me-2"
//                                 type="search"
//                                 placeholder="Search"
//                                 aria-label="Search"
//                             />
//                             <button
//                                 className="btn btn-outline-success"
//                                 type="submit"
//                             >
//                                 Search
//                             </button>
//                         </form>
//                     </div>
//                 </div>
//             </nav>
//         </>
//     );
// };

function Mnavbar()
{
    return (
        <>
            <nav className="navbar navbar-expand-lg bg-success sticky-top" style={{ width: "100%" }} >
                <div className="container-fluid" style={{ width: "100%", height: "auto" }} >
                    <img src={Gatisheellogo} style={{ width: "60px", height: "60px" }} alt=" " />
                    <a className="navbar-brand ps-3" href="https://www.gatisheel.com/" style={{color: "white",fontSize: "30px",fontWeight: "bold"}} >
                        GATISHEEL{" "}
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div
                        className="collapse navbar-collapse"
                        id="navbarSupportedContent"
                    >
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            
                            <Navtab1 />
                            <Navtab2 />
                            <Navtab3 />
                        </ul>

                        <ul className="navbar-nav mb-2 mb-lg-0">
                            <li className="nav-item">
                                <span className="nav-link" > Enquire Now</span>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://wa.me/+919518802185" target="_blank " rel="noreferrer" ><i className="fa-brands fa-whatsapp fa-2x"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};



export default Mnavbar;
